import script from "./RedirecionamentoSolicitacoesView.vue?vue&type=script&setup=true&lang=js"
export * from "./RedirecionamentoSolicitacoesView.vue?vue&type=script&setup=true&lang=js"

import "./RedirecionamentoSolicitacoesView.vue?vue&type=style&index=0&id=5d470abe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d470abe"]])

export default __exports__